import "core-js/modules/es.array.map";
import "core-js/modules/es.object.to-string";
import "core-js/modules/es.regexp.to-string";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import { loadMoreList, serchSelect } from "@/mixins/index";
import addserversList from "./components/addserversList";
import serversListView from "./components/serversListView";
import serversListextendView from "./components/serversListextendView";
import scheduledTask from "./components/scheduledTask";
export default {
  name: "serversList",
  mixins: [loadMoreList, serchSelect, serversListView],
  components: {
    addserversList: addserversList,
    serversListView: serversListView,
    serversListextendView: serversListextendView,
    scheduledTask: scheduledTask
  },
  data: function data() {
    return {
      pagingReqFn: "paymentGamesServersData",
      pagingReqValue: "data",
      drawer: false,
      content: '',
      gameList: []
    };
  },
  activated: function activated() {
    var _this = this;

    this.$api.paymentGamesData().then(function (res) {
      if (res.code == 0) {
        _this.gameList = res.data;
      }
    });
  },
  created: function created() {
    this.getList();
  },
  methods: {
    consynopsistentView: function consynopsistentView(row) {
      this.content = row.recharge_desc;
      this.drawer = true;
    },
    openView: function openView(row) {
      this.$refs.serversListView.init(row);
    },
    capy: function capy(row) {
      //创建一个input框
      var input = document.createElement("input"); //将指定的DOM节点添加到body的末尾

      document.body.appendChild(input); //设置input框的value值为直播地址

      input.setAttribute("value", row.id); //选取文本域中的内容

      input.select(); //copy的意思是拷贝当前选中内容到剪贴板
      //document.execCommand（）方法操纵可编辑内容区域的元素
      //返回值为一个Boolean，如果是 false 则表示操作不被支持或未被启用

      if (document.execCommand("copy")) {
        document.execCommand("copy");
      } //删除这个节点


      document.body.removeChild(input);
      this.$message.success('复制成功');
    },
    del: function del(data) {
      var _this2 = this;

      var ids = data.map(function (item) {
        return item.id;
      });
      this.$store.dispatch('d2admin/method/deleteList', {
        req: 'paymentGamesServersDel',
        data: {
          id: ids.toString()
        }
      }).then(function () {
        _this2.getList(_this2.paramsData.page);
      });
    }
  }
};